import type { VisualContent } from '../interfaces/domain/menu';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;

const toAssetUrl = (u: unknown, restaurantId: string): string => {
  const s = typeof u === 'string' ? u.trim() : '';
  if (!s) return '';
  if (s.startsWith('http') || s.startsWith('data:') || s.startsWith('blob:')) return s;
  if (s.startsWith('/')) return s;
  return SUPABASE_URL
    ? `${SUPABASE_URL}/storage/v1/object/public/banner-images/${restaurantId}/${s}`
    : `/${s}`;
};

export const normalizeVisualContent = (raw: unknown[], restaurantId: string): VisualContent[] =>
  (raw || [])
    .filter(Boolean)
    .map((it: unknown) => {
      const item = it as Record<string, unknown>;
      return {
        id: String(item?.id ?? item?.contentID ?? ''),
        title: typeof item?.title === 'string' ? item.title : '',
        link: typeof (item?.link ?? item?.linkTo) === 'string'
          ? String(item.link ?? item.linkTo)
          : undefined,
        image_url: toAssetUrl(item?.image_url ?? item?.imageURL, restaurantId),
        is_active: (item?.is_active ?? item?.visibility ?? true) as boolean,
        position:
          typeof item?.position === 'number' ? item.position
          : typeof item?.priority === 'number' ? item.priority
          : 0,
      };
    })
    .filter((x) => !!x.image_url);
